import {useContext} from 'react'
import RouteInfoContext from './context'

const useCurrentLocale = (): string | undefined => {
  const {currentLocale} = useContext(RouteInfoContext)

  return currentLocale
}

export default useCurrentLocale
